export default {
  'Unionfab On-Demand Manufacture': 'Unionfab On-Demand Manufacture',
  'Copyright Notice © Shanghai Unionfab Co.,Ltd All Rights Reserved.':
    'Copyright Notice © Shanghai Unionfab Co.,Ltd All Rights Reserved.',
};
